/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/merchant'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({ id: 'MENU.MERCHANT.INFO' })}
        fontIcon='bi-building'
      />
      <AsideMenuItem
        to='/report/transactions'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({ id: 'MENU.TRANSACTIONS' })}
        fontIcon='bi-building'
      />
      <AsideMenuItem
        to='/payment'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({ id: 'MENU.PAYMENT' })}
        fontIcon='bi-building'
      />

      <AsideMenuItemWithSub to='/linkpayment' title={intl.formatMessage({ id: 'MENU.LINKPAYMENT' })}>
        <AsideMenuItem to='/linkpayment/create' title={intl.formatMessage({ id: 'MENU.LINKPAYMENT.CREATE' })} hasBullet={true} />
        <AsideMenuItem to='/linkpayment/history' title={intl.formatMessage({ id: 'MENU.LINKPAYMENT.HISTORY' })} hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem
        to='/user'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({ id: 'MENU.USERS' })}
        fontIcon='bi-building'
      />

      <AsideMenuItemWithSub to='/report' title={intl.formatMessage({ id: 'MENU.REPORTS' })}>
        <AsideMenuItem to='/report/dailysummary' title={intl.formatMessage({ id: 'MENU.REPORTS.DAILYSUMMARY' })} hasBullet={true} />
      </AsideMenuItemWithSub>
    </>
  )
}
